import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { HistorialpagosService } from './historialpagos.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Overlay } from '@angular/cdk/overlay';
import { pagos } from './models/pagos';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';


export interface DialogData {
  nrocta: string;
  
}

@Component({
  selector: 'app-historialpagos',
  templateUrl: './historialpagos.component.html',
  styleUrls: ['./historialpagos.component.scss'],
  providers: [HistorialpagosService],
})
export class HistorialpagosComponent implements OnInit {

  historialpagos: pagos;
  nrocta: string; 
  isVisible = false;
  error:string;
  mensaje:string;
  selectedcuota :number;
  selectedanio :number;

  constructor(private service: HistorialpagosService,  public dialogRef: MatDialogRef<HistorialpagosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.datos(data.nrocta);
  }

  ngOnInit() {
    
    this.gethistorialpagos(this.nrocta,null,null);
     
  }
  
  datos(nrocta: string): void {     
    this.nrocta = nrocta;
   
  }

  gethistorialpagos(nrocta: string, anio:number, cuota:number): void {
    this.isVisible = true;
    this.service.getPagos(nrocta,anio,cuota).subscribe((response) => {
      debugger;
        if (response["length"] > 0)
          this.historialpagos = response;
        else
          this.mensaje = 'No existen pagos realizados para la cuenta.'

        this.isVisible = false;
    });
  }

  getconsultapagos(anio:number, cuota:number): void {
    this.isVisible = true;
    this.service.getPagos(this.nrocta,anio,cuota).subscribe((response) => {
      debugger;
        if (response["length"] > 0){
          this.historialpagos = response;
          this.mensaje = '';
        }
        else{
          this.mensaje = 'No existen pagos realizados para la cuenta.';
          this.historialpagos = null;
        }

        this.isVisible = false;
    });
  }

  
  
 

}
